
import { useState, useEffect} from "react";

import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    Approves,
    BigToString,
    MAX256
} from '../../ethers/e'


import {useEthers} from '../../ethers'
import useButtonText from '../useButtonText'
import useInput from '../useInput';
import useToast from '../useToast'

// import {useSilver} from '../../context/silver'
import {
    SilverPool,
    Usdt,
    Multi
} from '../../chain/silver'

import {
    isETHAddress,
    // getUrlParams
} from '../../utils'

function Error(e) {
    console.log(e)
    return e.data ? e.data.data ? e.data.data.message : (e.data.message ? e.data.message : e.message) : e.message
}


const INIT_DATA = {
    totalLockedUSDG: 0,
    totalGoldUnlcokableUSDG: 0,
    supplyOfUSDG: 0,
    totalUnlockedUSDG: 0,
    hardCap: 0,
    interest7Days: 0,
    recruitmentTime: 0,
    silverRewardRate: 0,
    locked: 0,
    totalNeed: 0
}
async function InitData() {
    const silverContract = SilverPool()
    // const usdt = Usdt()
    const multiCall = Multi()
    // console.log(account, await usdt.contract.balanceOf(account),' account')
    
    const results = await multiCall.all({
        silverPools: silverContract.calls.allPool(),
        // silverPoolsOfUser: silverContract.calls.getUserPools(account),
        // pool funds total - totalUnlockedUSDG = locked USDG
        totalLockedUSDG: silverContract.calls.totalUnlockedUSDG(),
        totalGoldUnlcokableUSDG: silverContract.calls.totalGoldUnlcokableUSDG(),
        supplyOfUSDG: silverContract.calls.supplyOfUSDG(),
        totalUnlockedUSDG: silverContract.calls.supplyOfUSDG(),
        interest7Days: silverContract.calls.interest7Days(),
        recruitmentTime: silverContract.calls.recruitmentTime(),
        hardCap: silverContract.calls.hardCap(),
        silverRewardRate: silverContract.calls.silverRewardRate(),

    })

    const totalLockedUSDG = WeiToUnits(results.totalLockedUSDG)
    const totalGoldUnlcokableUSDG = WeiToUnits(results.totalGoldUnlcokableUSDG)
    const supplyOfUSDG = WeiToUnits(results.supplyOfUSDG)
    const totalUnlockedUSDG = WeiToUnits(results.totalUnlockedUSDG)
    const hardCap = WeiToUnits(results.hardCap)
    const interest7Days = results.interest7Days.toNumber() / 10000
    const recruitmentTime = results.recruitmentTime.toNumber()
    const silverRewardRate = results.silverRewardRate.toNumber() / 10000

    // locked,
    // total: locked + supplyOfUSDG,
    let locked = BN(0)
    results.silverPools.forEach(v => {
        locked = locked.add(v.fundsRaised)
        if (v.endTime.toNumber() > 1) {
            locked = locked.add(v.fundsRaised.mul(v.interestPayableRate).div(10000))
        }
    });

    let totalNeed = results.supplyOfUSDG.add(locked)
    totalNeed = WeiToUnits(totalNeed)
    locked = locked.sub(results.totalLockedUSDG)
    locked = WeiToUnits(locked)
    return {
        totalLockedUSDG,
        totalGoldUnlcokableUSDG,
        supplyOfUSDG,
        totalUnlockedUSDG,
        hardCap,
        interest7Days,
        recruitmentTime,
        silverRewardRate,
        locked,
        totalNeed
    }
}

export function useAdmin() {
    const {account, getBlockNumber} = useEthers()
    const [data, setState] = useState(INIT_DATA)
    const blockNumber = getBlockNumber()
    useEffect(() => {
        const init = async () => {
            setState(
                await InitData()
            )
        }
        if (account !== DEFAULT_ACCOUNT) init()
    }, [account, blockNumber])
    return data
}

export function useSetConfiguration() {
    const hardCap = useInput("", {type: "number", placeholder: "0.0"})
    const interest7Days = useInput("", {type: "number", placeholder: "0.0"})
    const recruitmentTime = useInput("", {type: "number", placeholder: "0.0"})
    const silverRewardRate = useInput("", {type: "number", placeholder: "0.0"})

    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Approve')

    button.onClick = async () => {
        loadingButton("Pending")
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.setPoolConfiguration(
                interest7Days.value*10000,
                silverRewardRate.value*10000,
                recruitmentTime.value,
                EtherToWei(hardCap.value*1)
            )
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open("Success")
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }
    return {
        button,
        input: {
            hardCap,
            interest7Days,
            recruitmentTime,
            silverRewardRate
        }
    }
}

export function useFounderApprove() {
    // const {account} = useEthers()
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Approve')

    button.onClick = async () => {
        loadingButton("Pending")
        const silverPool = SilverPool()
        const usdt = Usdt()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await usdt.contract.approve(silverPool.address, MAX256)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open("Success")
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}

export function useGoldVIP() {
    const [isVIP, setVip] = useState(false)
    const inputAddress = useInput('')
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Set VIP')

    button.onClick = async () => {
        loadingButton("Pending")
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.bindGold(inputAddress.value)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open("Success")
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    const checkUser = async () => {
        const silverPool = SilverPool()
        const user = await silverPool.goldUser(inputAddress.value)
        setVip(user.isVIP+'')
    }

    useEffect(() => {
        if (isETHAddress(inputAddress.value)) {
            checkUser()
        }
    }, [inputAddress.value])

    return {
        button,
        inputAddress,
        isVIP
    }
}


export function useSilverVIP() {
    const [isVIP, setVip] = useState(false)
    const inputAddress = useInput('')
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Set VIP')

    button.onClick = async () => {
        loadingButton("Pending")
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.bindSilver(inputAddress.value)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open("Success")
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    const checkUser = async () => {

        const silverPool = SilverPool()
        const user = await silverPool.userWallet(inputAddress.value)
        // console.log(user)
        setVip(user.isSilverVIP+'')
    }

    useEffect(() => {
        if (isETHAddress(inputAddress.value)) {
            console.log(inputAddress.value)
            checkUser()
        }
    }, [inputAddress.value])

    return {
        button,
        inputAddress,
        isVIP
    }
}